import React, { Component } from 'react';
import { connect } from 'react-redux';
import PrivacyContentDe from './PrivacyContentDe';
import PrivacyContentEn from './PrivacyContentEn';
import Link from "react-router-dom/es/Link";

 class Privacy extends Component {

  render() {
    return (
      <div className="view">
        {
          this.props.language.map != null ?
            <div>
              <div style={{textAlign:"center"}}>
                  <button style={{marginTop:"50px", marginBottom: "2em"}}className="btn btn-outline-primary" onClick={(e) => this.props.history.goBack()}>{this.props.language.map.labels.common.back}</button>
              </div>
              {
                this.props.language.active === "de" ? 
                <PrivacyContentDe/>
                :
                <PrivacyContentEn/>
              }
              <div style={{textAlign:"center"}}>
                  <button style={{marginTop:"50px", marginBottom: "2em"}}className="btn btn-outline-primary" onClick={(e) => this.props.history.goBack()}>{this.props.language.map.labels.common.back}</button>
              </div>
            </div>
            :
            null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  language: state.application.language
});

const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(Privacy);



// WEBPACK FOOTER //
// ./src/modules/privacy/view/Privacy.js